import { defineStore } from 'pinia'
import Actions from './actions'
import Getters from './getters'
import { useState } from './state'

export { type PriceState } from './state'

export const usePriceStore = defineStore('price', {
  state: useState,
  getters: { ...Getters },
  actions: { ...Actions },
})

export type PriceStoreContext = ReturnType<typeof usePriceStore>